var styles = {"buttonGroup":"ButtonGroup-module_buttonGroup__UNYq6"};

export { styles as default };
